import React from 'react';
import { Layout } from 'antd';

import Home from './Home';

const { Content } = Layout;

const App = () => {
  return (
    <Layout hasSider>
      <Layout style={{ background: '#fff', paddingTop: '2rem' }}>
        <Content style={{ height: '100%' }}>
          <Home />
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
